import * as React from "react";
import { Button, OutlineButton } from "components/button";
import { useTranslation } from "react-i18next";

type Props = {
  values: Record<string, unknown> | null;
  onConfirm: () => void;
  onCancel: () => void;
};

function formatDate(dateVal: string): string {
  const parts = dateVal.trim().split("-");
  if (parts.length === 3) {
    const [year, month, day] = parts;
    return `${month}-${day}-${year}`;
  }
  return "";
}

function formatTimeTo12Hr(timeVal: string): string {
  const parts = timeVal.trim().split(":");
  if (parts.length >= 2) {
    const hours = Number(parts[0]);
    const minutes = Number(parts[1]);
    if (
      !Number.isNaN(hours) &&
      !Number.isNaN(minutes) &&
      hours >= 0 &&
      hours <= 23 &&
      minutes >= 0 &&
      minutes <= 59
    ) {
      const h12 = String(hours % 12 || 12).padStart(2, "0");
      return `${h12}:${String(minutes).padStart(2, "0")} ${hours >= 12 ? "PM" : "AM"}`;
    }
  }
  return "";
}

export default function AppointmentConfirmationPopup({
  values,
  onConfirm,
  onCancel,
}: Props) {
  const { t } = useTranslation();
  const tBase = "containers.appointmentCard.appointment-folder.appointmentModal";
  const tr = (key: string) => t(`${tBase}.${key}`);

  const rawDate = (values?.date as string) || "";
  const rawStartTime = (values?.start_time_utc as string) || "";
  const rawEndTime = (values?.end_time_utc as string) || "";

  const formattedDate = formatDate(rawDate);
  const formattedStartTime = formatTimeTo12Hr(rawStartTime);
  const formattedEndTime = formatTimeTo12Hr(rawEndTime);

  return (
    <div
      role="dialog"
      aria-labelledby="appointment-missing-confirm-title"
      className="bg-white rounded-lg p-4 max-w-[560px] shadow-md"
    >
      <h2 id="appointment-missing-confirm-title" className="m-0 mb-2">
        {tr("Missing appointment information")}
      </h2>
      <div className="mb-3 text-sm">
        <p>
          {tr("Appointment Missing Message")}
        </p>

        <div className="flex gap-2 mt-1">
          <strong>{tr("Date")}:</strong>
          <span className={formattedDate ? "" : "text-red-500"}>
            {formattedDate || tr("Missing")}
          </span>
        </div>
        <div className="flex gap-2 mt-1">
          <strong>{tr("Start Time")}:</strong>
          <span className={formattedStartTime ? "" : "text-red-500"}>
            {formattedStartTime || tr("Missing")}
          </span>
        </div>
        <div className="flex gap-2 mt-1">
          <strong>{tr("End Time")}:</strong>
          <span className={formattedEndTime ? "" : "text-red-500"}>
            {formattedEndTime || tr("Missing")}
          </span>
        </div>
      </div>

      <div className="flex gap-2 justify-end">
        <Button type="button" primary onClick={onConfirm}>
          {tr("Yes")}
        </Button>
        <OutlineButton type="button" onClick={onCancel}>
          No
        </OutlineButton>
      </div>
    </div>
  );
}



